export const AuthTime = {
  SevenDay: 7,
  ThreeDay: 3,
  OneDay: 1,
  Custom: 4,
};
export const PlatformCodeMap = {
  WebSide: 2,
  AnimationClients: 1,
  RenderingClient: 3,
};
